import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import categoriesService from "services/admin/categoriesService";
import { statusesData } from "enums/statusEnum";
import { CustomFields } from "components/CustomFields/CustomFields";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

const CategoryForm = ({
  router: {
    navigate,
    params: { id },
    queryParams
  },
  data: { category },
}) => {

  const methods = useForm({
    defaultValues: {
      name: category?.name,
      status: category?.status,
      specifications: category?.specifications || []
    }
  })

  const onSubmit = async (formValues) => {
    console.log("formValues: ", formValues);
    try {
      if (category) {
        await categoriesService.put(id, formValues)
        snack("Категория обновлен успешно!");
      } else {
        if (queryParams.get('parentID')) {
          formValues.parentID = queryParams.get('parentID')
        }
        await categoriesService.post(formValues)
        snack("Категория создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={category ? 'Редактирование категории' : 'Создание категории'} >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="m-b-16">
            <TextField type="text" name="name" {...methods.register('name')} required fullWidth className="m-b-16" label="Название" />
          </div>
          <div className="m-b-16">
            <Controller control={methods.control} name="status" rules={{ required: true }} render={({ field }) => {
              return <FormControl fullWidth>
                <InputLabel>Статус</InputLabel>
                <Select {...field} required>
                  {statusesData.map((status) => (
                    <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            }}></Controller>
          </div>
          <CustomFields specifications={category?.specifications || []} />
          <Button type="submit" variant="contained" className="m-t-16" fullWidth>Сохранить категорию</Button>
          <pre className="m-t-16">{JSON.stringify(methods.watch(), null, 2)}</pre>
        </form>
      </FormProvider>
    </CrudPage >
  );
};

export default withRouter(
  withRemoteDataAndSpinner(CategoryForm, (router) => {
    let requests = {}
    if (router.params.id) {
      requests['category'] = () => categoriesService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
